<app-header></app-header>
<app-botao-chat></app-botao-chat>

<div class="container py-4">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <app-breadcrumb></app-breadcrumb>
        <h1 class="titulo">Visualizar erros de importação</h1>
        <p class="paragrafo mb-4">Visualize erros referentes ao layout</p>
        <ul class="nav nav-tabs border-0" id="myTab">
          <li class="nav-item me-4">
            <a class="nav-link active" id="erros-layout-tab" data-bs-toggle="tab" href="#erros-layout" aria-controls="erros-layout">Erros de Layout @if (errosLayout) {
              <span class="badge text-bg-danger">{{qtdeErrosLayout}}</span>
            }</a>
          </li>
        </ul>

        <!-- CONTEÚDO DENTRO DAS TABS -->
        <div class="tab-content" id="myTabContent">

          <!-- CONTEÚDO ABA ERRO LAYOUT -->
          @if (errosLayout) {
            <div class="tab-pane show active fade" id="erros-layout" role="tabpanel" aria-labelledby="erros-layout-tab">
              @if (qtdeErrosLayout != 0) {
                <div class="row">
                  <div class="col-12">
                    <!-- QUANDO TEM ERROS DE LAYOUT TABELA -->
                    <table class="table table-hover border-bottom my-4 w-100">
                      <caption>Tabela que apresenta erros de importação do arquivo</caption>
                      <thead>
                        <tr class="border-tr">
                          <th scope="col">ERRO</th>
                          <th scope="col">LINHA</th>
                          <th scope="col">ID IMPORTAÇÃO</th>
                          <th scope="col">DESCRIÇÃO</th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (erroLayout of errosLayout; track erroLayout; let i = $index) {
                          <tr>
                            <td>{{erroLayout.type | camelCase}}</td>
                            <td>{{erroLayout.line}}</td>
                            <td>{{erroLayout.importId}}</td>
                            <td>
                              @for (erro of erroLayout.errors; track erro; let iErro = $index) {
                                <p class="info-card">
                                  <strong>Erro {{iErro + 1}}:</strong>
                                  {{erro.description}}
                                  @if (erro.field !== undefined && erro.field !== null && erro.field !== '') {
                                    <span>| Campo com erro: {{erro.field}}</span>
                                  }
                                </p>
                              }
                            </td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                  <div class="col-12 text-center">
                    <button class="botao-baixar-relatorio" id="btnBaixarRelatorio" (click)="baixarRelatorioLayout()"
                    [tag]="addTagManagerInteraction('box:button:click', 'baixar-relatorio-completo')">BAIXAR RELATÓRIO COMPLETO</button>
                  </div>
                </div>
              }
              <!-- QUANDO NÃO TEM ERROS -->
              @if (qtdeErrosLayout === 0) {
                <div class="row py-3">
                  <div class="col-12 text-center">
                    <h3 class="titulo-sem-inconsistencias">Tudo certo! ✓</h3>
                    <p class="descricao-sem-inconsistencias">Você não possui erros de LAYOUT no seu arquivo.</p>
                  </div>
                </div>
              }
            </div>
          }

        </div>

        <!-- LOADING -->
        @if (errosLayout === null) {
          <div class="row py-3 text-center">
            <div class="col-12">
              <div class="text-center">
                <output class="spinner-border c-primary">
                  <span class="visually-hidden">Consultando os erros referrentes a importação ...</span>
                </output>
              </div>
              <p class="legenda-spinner">Consultando os erros referrentes a importação</p>
            </div>
          </div>
        }

        <!-- CASO DE ERRO NA API DE LAYOUT -->
        @if (errosLayout === false) {
          <div class="row py-3">
            <div class="col-12 text-center">
              <h3 class="titulo-erro">Ocorreu um erro!</h3>
              <p class="descricao-sem-inconsistencias">Não foi possível consultar os erros referentes ao layout, devido a uma falha em nosso sistema.</p>
            </div>
          </div>
        }

        <div class="row text-center">
          <button class="botao-outline mt-4 ajuste-botao" id="btnVoltarImportarArquivo" (click)="cancelarImportacao()"
          [tag]="addTagManagerInteraction('box:button:click', 'voltar-e-importar-outro-arquivo')">VOLTAR E IMPORTAR OUTRO ARQUIVO</button>
        </div>

      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>
